import { CL } from './featuresCL';
import { MX } from './featuresMX';
// eslint-disable-next-line import/prefer-default-export
export const features = {
  CL,
  MX,
};

export const pathGlobalActive = ['/orders', '/business'];
